import { render, staticRenderFns } from "./createFeedback.vue?vue&type=template&id=cd56a00a&scoped=true"
import script from "./createFeedback.vue?vue&type=script&lang=js"
export * from "./createFeedback.vue?vue&type=script&lang=js"
import style0 from "./createFeedback.vue?vue&type=style&index=0&id=cd56a00a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd56a00a",
  null
  
)

export default component.exports